import { createFileRoute } from '@tanstack/react-router'

import {
  useFetchDirectoryAccounts,
  useFetchProject,
  useFetchTransactions,
} from '@/modules/projects'
import { ProjectTransactionsPage } from '@/modules/projects/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/transactions',
)({
  component: ProjectTransactions,
  validateSearch: (search: Record<string, unknown>) => {
    const result: Record<string, string | number | undefined> = {
      page: search.page ? Number(search.page) : undefined,
      perPage: search.perPage ? Number(search.perPage) : undefined,
    }
    return result
  },
})

function ProjectTransactions() {
  const { slug } = Route.useParams()
  useFetchProject(slug)
  useFetchTransactions(slug)
  useFetchDirectoryAccounts(slug)

  return <ProjectTransactionsPage slug={slug} />
}
